(function () {

  function initRockTheLook(scope = document) {

    let sections = [];

    if (
      scope.classList &&
      scope.classList.contains("rock-the-look-section")
    ) {

      sections = [scope];

    } else if (scope.querySelectorAll) {

      sections = Array.from(
        scope.querySelectorAll(".rock-the-look-section")
      );

    }


    sections.forEach((section) => {

      if (section.dataset.rockInitialized === "true") {
        return;
      }

      section.dataset.rockInitialized = "true";


      const modal =
        section.querySelector(".rock-look-modal");

      const modalBody =
        section.querySelector(".rock-modal-body");

      const closeButton =
        section.querySelector(".rock-modal-close");

      const overlay =
        section.querySelector(".rock-modal-overlay");

      const grid =
        section.querySelector("[data-rock-look-grid]");

      const loadMoreButton =
        section.querySelector("[data-rock-load-more]");


      /*
        ==========================
        POPUP
        ==========================
      */

      if (modal && modalBody) {

        section.addEventListener("click", function (event) {

          const button = event.target.closest(
            ".rock-look-image-button"
          );

          if (!button) return;

          if (!section.contains(button)) return;


          const item = button.closest(
            ".rock-look-item"
          );

          if (!item) return;


          const template = item.querySelector(
            ".rock-look-template"
          );

          if (!template) return;


          modalBody.innerHTML =
            template.innerHTML;


          modal.classList.add("active");

          modal.setAttribute(
            "aria-hidden",
            "false"
          );


          document.body.style.overflow =
            "hidden";

        });


        function closePopup() {

          if (
            !modal.classList.contains("active")
          ) {
            return;
          }


          modal.classList.remove("active");


          modal.setAttribute(
            "aria-hidden",
            "true"
          );


          modalBody.innerHTML = "";


          document.body.style.overflow =
            "";

        }


        if (closeButton) {

          closeButton.addEventListener(
            "click",
            closePopup
          );

        }


        if (overlay) {

          overlay.addEventListener(
            "click",
            closePopup
          );

        }


        const escapeHandler = function (event) {

          if (
            event.key === "Escape" &&
            modal.classList.contains("active")
          ) {

            closePopup();

          }

        };


        document.addEventListener(
          "keydown",
          escapeHandler
        );

      }


      /*
        ==========================
        LOAD MORE
        ==========================
      */

      if (grid) {

        const items = Array.from(
          grid.querySelectorAll(
            "[data-rock-look-item]"
          )
        );


        /*
          Mobile breakpoint must match CSS.
        */

        const mobileQuery =
          window.matchMedia(
            "(max-width: 600px)"
          );


        function getSettings() {

          if (mobileQuery.matches) {

            return {

              initial:
                parseInt(
                  grid.dataset.initialMobile,
                  10
                ) || 4,

              load:
                parseInt(
                  grid.dataset.loadMobile,
                  10
                ) || 4

            };

          }


          return {

            initial:
              parseInt(
                grid.dataset.initialDesktop,
                10
              ) || 10,

            load:
              parseInt(
                grid.dataset.loadDesktop,
                10
              ) || 5

          };

        }


        let currentMode =
          mobileQuery.matches
            ? "mobile"
            : "desktop";


        let settings =
          getSettings();


        /*
          Number currently shown.
        */

        let visibleCount =
          Math.min(
            settings.initial,
            items.length
          );


        /*
          Show/hide correct items.
        */

        function renderItems(animateItems = []) {

          items.forEach(
            function (item, index) {

              if (index < visibleCount) {

                item.classList.remove(
                  "rock-look-item--hidden"
                );

              } else {

                item.classList.add(
                  "rock-look-item--hidden"
                );

                item.classList.remove(
                  "rock-look-item--reveal"
                );

              }

            }
          );


          /*
            Animate newly revealed items.
          */

          animateItems.forEach(
            function (item, index) {

              item.classList.add(
                "rock-look-item--reveal"
              );


              window.setTimeout(
                function () {

                  item.classList.remove(
                    "rock-look-item--reveal"
                  );

                },
                450 + index * 40
              );

            }
          );


          /*
            Load More button visibility.
          */

          if (loadMoreButton) {

            if (
              visibleCount >= items.length
            ) {

              loadMoreButton.classList.add(
                "is-hidden"
              );

            } else {

              loadMoreButton.classList.remove(
                "is-hidden"
              );

            }

          }

        }


        /*
          Initial rendering.
        */

        renderItems();


        /*
          Load More click.
        */

        if (loadMoreButton) {

          loadMoreButton.addEventListener(
            "click",
            function () {

              settings =
                getSettings();


              const previousVisibleCount =
                visibleCount;


              visibleCount =
                Math.min(
                  visibleCount + settings.load,
                  items.length
                );


              const newlyVisibleItems =
                items.slice(
                  previousVisibleCount,
                  visibleCount
                );


              renderItems(
                newlyVisibleItems
              );

            }
          );

        }


        /*
          ==========================
          DESKTOP / MOBILE SWITCH
          ==========================

          When crossing the 600px
          breakpoint, reset to the
          appropriate initial count.

          Example:
          Desktop initial = 10
          Mobile initial = 4

          Resize desktop -> mobile:
          resets to 4.

          Mobile -> desktop:
          resets to 10.
        */

        function handleBreakpointChange() {

          const newMode =
            mobileQuery.matches
              ? "mobile"
              : "desktop";


          if (newMode === currentMode) {
            return;
          }


          currentMode =
            newMode;


          settings =
            getSettings();


          visibleCount =
            Math.min(
              settings.initial,
              items.length
            );


          renderItems();

        }


        /*
          Modern browsers
        */

        if (
          typeof mobileQuery.addEventListener ===
          "function"
        ) {

          mobileQuery.addEventListener(
            "change",
            handleBreakpointChange
          );

        } else {

          /*
            Older Safari fallback.
          */

          mobileQuery.addListener(
            handleBreakpointChange
          );

        }

      }

    });

  }


  /*
    ==========================
    INITIAL LOAD
    ==========================
  */

  if (
    document.readyState === "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      function () {

        initRockTheLook(document);

      }
    );

  } else {

    initRockTheLook(document);

  }


  /*
    ==========================
    SHOPIFY THEME EDITOR
    ==========================
  */

  document.addEventListener(
    "shopify:section:load",
    function (event) {

      initRockTheLook(
        event.target
      );

    }
  );

})();